<template>
  <div class="image-preview-container">
    <div v-if="images && images.length"
         class="image-list row"
    >
      <div v-for="(image, index) in images"
           :key="index"
           class="image-item col-3"
      >
        <div class="image-wrapper">
          <img v-image-preview
               :src="`${image.img}`"
               class="img-fluid rounded"
               :alt="`Image ${index + 1}`"
               height="300"
               width="250"
          >
          <div class="image-actions mt-2">
            <b-button variant="outline-primary"
                      size="sm"
                      class="mr-2"
                      @click="editImage(index)"
            >
              <feather-icon
                icon="EditIcon"
              /> Edit
            </b-button>
            <b-button variant="outline-danger"
                      size="sm"
                      @click="deleteImage(index)"
            >
              <feather-icon
                icon="TrashIcon"
              /> Delete
            </b-button>
          </div>
        </div>

        <b-modal :id="`edit-image-${index}`"
                 :title="`Edit Image ${index + 1}`"
        >
          <b-form-group label="Image Description:">
            <b-form-textarea
              v-model="images[index].description"
              rows="3"
              placeholder="Enter image description"
            />
          </b-form-group>
        </b-modal>
      </div>
    </div>
    <div v-else
         class="no-images text-center p-4"
    >
      <feather-icon
        icon="ImageIcon"
        size="48"
        class="text-muted mb-2"
      />
      <p class="text-muted">
        No images available
      </p>
    </div>
  </div>
</template>

<script>
import {
  BButton,
  BModal,
  BFormGroup,
  BFormTextarea,

} from 'bootstrap-vue'

export default {
  name: 'ImagePreview',
  components: {
    BButton,
    BModal,
    BFormGroup,
    BFormTextarea,
  },
  props: {
    images: {
      type: Array,
      default: () => [],
    },
  },
  methods: {
    editImage(index) {
      // Initialize description if not already set
      if (!this.images[index].description) {
        this.images[index].description = ''
      }
      this.$bvModal.show(`edit-image-${index}`)
    },
    deleteImage(index) {
      // Confirm before deleting
      this.$bvModal.msgBoxConfirm('Are you sure you want to delete this image?', {
        title: 'Confirm Delete',
        okVariant: 'danger',
        okTitle: 'Delete',
        cancelTitle: 'Cancel',
        hideHeaderClose: false,
      })
        .then(value => {
          if (value) {
            // Remove the image at the specified index
            this.images.splice(index, 1)
          }
        })
        .catch(error => {
          // Handle error if needed
          console.error('Error in delete confirmation:', error)
        })
    },
  },
}
</script>

<style scoped>
.image-preview-container {
  width: 100%;
}

.image-item {
  max-width: 100%;
}

.image-item img {
  width: 250px;
  height: 300px;
  object-fit: contain;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
}

.image-wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.image-actions {
  display: flex;
  justify-content: center;
}

.no-images {
  border: 1px dashed #ccc;
  border-radius: 4px;
}
</style>
